import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 0;
`;

export const MainContent = styled.div<{ $noPadding?: boolean }>`
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 0;
  width: 100%;
  overflow-y: auto;

  background-color: #f6f1e7;
  padding: ${({ $noPadding }) => ($noPadding ? '0' : '0.5rem 0.5rem 0 0.5rem')};

  @media (min-width: 640px) {
    padding: ${({ $noPadding }) => ($noPadding ? '0' : '0.5rem 1rem 0 1rem')};
  }

  @media (min-width: 768px) {
    padding: ${({ $noPadding }) =>
      $noPadding ? '0' : '0.5rem 1.5rem 0 1.5rem'};
  }

  @media (min-width: 1024px) {
    padding: ${({ $noPadding }) => ($noPadding ? '0' : '0.5rem 2rem 0 2rem')};
  }

  @media (min-width: 1280px) {
    padding: ${({ $noPadding }) => ($noPadding ? '0' : '0.5rem 3rem 0 3rem')};
  }
`;

export const MenuAppBarDiv = styled.div`
  box-shadow: rgba(0, 0, 0, 0.3) 0px 2px 4px 0px;
  position: relative;
  flex-shrink: 0;
`;

export const Footer = styled.footer`
  width: 100%;
  height: 54px;
  background-color: ${({ theme }) => theme.colors.footer.background};
  box-shadow: rgba(0, 0, 0, 0.3) 0px -2px 4px 0px;
  margin-top: 1px;
  padding: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;
